import type { AnonymousCalendarEvent } from '../utils/calendarEventUtils';
import { getCalendarEventDetailsStore } from '../store/calendarEventDetailsStore';

export default function getCalendarEvent(): AnonymousCalendarEvent {
    return getCalendarEventDetailsStore().calendarEvent;
}
